import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

registerLocaleData(localeEs, 'es');
import { NavigationEnd, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AuthService } from '../../services/auth.service';
import { KycService } from '../../services/kyc.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { KycService as ModalKycSrv } from '../../services/modal-kyc/kyc.service';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
// import { error } from 'jquery';
import { UiStateService } from 'src/app/services/ui-state.service';
import { Observable } from 'rxjs';
import { LoaderService } from '../../services/loader.service';
import { DigitalWalletService } from '../../services/digital-wallet.service';
import { SharedModule } from '../shared/shared.module';

@Component({
  selector: 'app-menu-desktop',
  templateUrl: './menu-desktop.component.html',
  styleUrls: ['./menu-desktop.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule, NgbCollapseModule, SharedModule, MatTooltipModule]
})
export class MenuDesktopComponent implements OnInit {
  private _userAuth: any = null;
  private _loggedIn: boolean = false;
  kycFlag: boolean = false;
  private adminState: { 
    timestamp: number;
    hash: string;
    verified: boolean;
  } | null = null;
  urlYoutube: string | null = null;
  urlLinkedIn: string | null = null;
  urlTwitter: string | null = null;
  urlInstagram: string | null = null;
  urlTelegram: string | null = null;
  digitalWalletCollapsed: boolean = false;
  referralsCollapsed: boolean = false;
  helpCollapsed: boolean = false;
  myInvestmentsCollapsed: boolean = false;
  balance: number = 0;
  balanceError: boolean = false;
  isLoadingBalance: boolean = false;
  loadingDots: string = '';
  hideBlockchain: boolean = true;
  canCheckBalance: boolean = false;
  firstTime: boolean = false;
  counter: number = 0;
  lock: boolean = false;

  // 🎨 UI STATE - KISS: Observable directo para template
  public readonly isMenuDesktopCollapsed$: Observable<boolean>;

  // Getter público para loggedIn
  get loggedIn(): boolean {
    return this._loggedIn;
  }

  // 🎛️ TOGGLE MENU - KISS: Una línea, simple y claro
  toggleMenuDesktop(): void {
    this.uiStateService.toggleMenuDesktop();
  }

  // Getter para exponer de forma segura el estado de admin
  get isAdmin(): boolean {
    return this.verifyAdminState();
  }

  private generateHash(timestamp: number, uid: string): string {
    // Implementación simple de hash, podría ser más compleja en producción
    return btoa(`${timestamp}-${uid}-${process.env['ADMIN_SALT'] || 'default-salt'}`);
  }

  private verifyAdminState(): boolean {
    if (!this.adminState || !this._userAuth) return false;
    
    // Verificar que el estado no haya expirado (30 segundos)
    const now = Date.now();
    if (now - this.adminState.timestamp > 30000) {
      this.adminState = null;
      this.checkAdminManually();
      return false;
    }

    // Verificar que el hash no haya sido manipulado
    const expectedHash = this.generateHash(this.adminState.timestamp, this._userAuth.uid);
    if (this.adminState.hash !== expectedHash) {
      this.adminState = null;
      return false;
    }

    return this.adminState.verified;
  }

  constructor(
    private authSrv: AuthService, 
    private kycSrv: KycService, 
    private afs: AngularFirestore, 
    private crf: ChangeDetectorRef,
    private router: Router,
    private modalKyc: ModalKycSrv,
    public fns: AngularFireFunctions,
    private loadingService: LoaderService,
    private digitalWalletSrv: DigitalWalletService,
    private uiStateService: UiStateService,
    private ngZone: NgZone
  ) {
    // 🔄 DRY: Asignar observable en constructor - consistente con patrón existente
    this.isMenuDesktopCollapsed$ = this.uiStateService.isMenuDesktopCollapsed$;

    this.syncDashboardSubmenuFromUrl(this.router.url);
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.syncDashboardSubmenuFromUrl(event.urlAfterRedirects ?? event.url ?? this.router.url);
      });

    // Iniciar verificación periódica
    setInterval(() => {
      if (this._loggedIn && this._userAuth) {
        this.checkAdminManually();
      }
    }, 30000); // Verificar cada 30 segundos
  }

  logout() {
    Swal.fire({
      icon: 'info',
      title: '¿Quieres salir de la aplicación?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Cancelar',
      cancelButtonText: `Ok`,
    }).then(async (result: any) => {
      if (!result.isConfirmed) {
        await this.authSrv.logout();
        this.router.navigateByUrl('/login');
        this.authSrv.reload();
      }
    });
  }

  formatVideo() {
    setTimeout(() => {
      const iytb: HTMLElement = document.getElementById('iframeYoutube') as HTMLElement;
      if (iytb === null) {
        this.formatVideo();
        return;
      }

      const width = iytb.offsetWidth;
      const height = iytb.offsetHeight;
      const proporcion = (height / width) + 0.3;
      iytb.setAttribute('height', String(width * proporcion));
    }, 1000);
  }

  ngOnInit(): void {
    this.authSrv.userAuth.subscribe((res: any) => {
      this._userAuth = res;
      this.afs.collection('users').doc(res?.uid).valueChanges().subscribe((user: any) => {
          // Firebase puede emitir fuera de la zona de Angular → forzamos CD.
          this.ngZone.run(() => {
            this.hideBlockchain = user?.hideBlockchain ?? true;
            this.crf.detectChanges();
          });
      });
      this.crf.detectChanges();
    });

    this.authSrv.loggedIn.subscribe((res: any) => {
      const previousLoggedIn = this._loggedIn;
      this._loggedIn = res != this._loggedIn ? res : this._loggedIn;
      if (this._loggedIn && this._loggedIn !== previousLoggedIn) {
        this.checkFunds();
        this.uiStateService.expandMenuDesktop();
      }
      this.crf.detectChanges();
    });

    this.authSrv.admin.subscribe((res: any) => {
      if (this._loggedIn && this._userAuth) {
        const timestamp = Date.now();
        this.adminState = {
          timestamp,
          hash: this.generateHash(timestamp, this._userAuth.uid),
          verified: res
        };
        
        if (!res) {
          this.checkAdminManually();
        }
      }
      this.crf.detectChanges();
    });

    this.kycSrv.kycSuccess.subscribe((res: any) => {
      this.kycFlag = res;
      this.canCheckBalance = res.success;
      this.crf.detectChanges();
    });

    this.digitalWalletSrv.currentBalance.subscribe((res: any) => {
      if (res) {
        this.balance = res.balance;
        this.balanceError = res.balanceError;
        this.isLoadingBalance = res.isLoadingBalance;
        this.crf.detectChanges();
      }
    });

    this.afs.collection('dapp').doc('HjdaO0nvpbsWq6LCF4fS').valueChanges().subscribe((res: any) => {
      // Firebase puede emitir fuera de la zona de Angular → forzamos CD.
      this.ngZone.run(() => {
        this.urlYoutube = res.urlYoutubeMenu;
        this.urlLinkedIn = res.urlLinkedInMenu;
        this.urlTwitter = res.urlTwitterMenu;
        this.urlInstagram = res.urlInstagramMenu;
        this.urlTelegram = res.urlTelegramMenu;
        this.crf.detectChanges();
      });
    });

    this.formatVideo();
  }

  private checkAdminManually() {
    if (!this._userAuth) return;
    
    this.afs.collection('administrators').doc(this._userAuth.uid).get().subscribe(doc => {
      if (doc.exists) {
        const adminData = doc.data() as any;
        if (adminData && (adminData.rol === 'admin' || adminData.rol === 'superadmin')) {
          const timestamp = Date.now();
          this.adminState = {
            timestamp,
            hash: this.generateHash(timestamp, this._userAuth.uid),
            verified: true
          };
          this.crf.detectChanges();
        }
      }
    });
  }

  goToAdmin() {
    if (this.verifyAdminState()) {
      this.router.navigate(['/administracion']);
    }
  }

  openModalKyc() {
    this.modalKyc.openModalKyc();
  }

  async checkFunds() {
    if(!this.firstTime){
      this.digitalWalletSrv.setBalance({
        isLoadingBalance: true,
        balance: 0
      });
      this.firstTime = true;
      await (new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(true);
        }, 5000)
      }))
    }
    if(this.canCheckBalance){
      this.counter++
      this.digitalWalletSrv.checkFunds();
      if(this.counter > 2){
        this.lockButton();
      }
    }
    else
      this.digitalWalletSrv.setBalance({
        isLoadingBalance: false,
        balanceError: true,
        canCheckBalance:false,
        balance: 0
      });
  }

  lockButton() {
    this.lock = true;
    setTimeout(() => {
      this.counter = 0;
      this.lock = false;
    }, 10000);
  }

  navigateToAddFunds() {
    this.router.navigate(['/cartera-digital/euros/ingresar-fondos']);
  }

  private syncDashboardSubmenuFromUrl(url: string): void {
    if (!url) return;
    if (url.includes('/inversiones')) {
      this.myInvestmentsCollapsed = true;
    }
  }
}
